import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { IapReconnectDialogComponent } from '@app/iap-reconnect-dialog/iap-reconnect-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    SharedModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  declarations: [ IapReconnectDialogComponent ],
  exports: [ IapReconnectDialogComponent ],
})
export class IapReconnectDialogModule { }
